import { render } from "./SkeletonJobCard.vue?vue&type=template&id=ae34e0c2&scoped=true"
const script = {}

import "./SkeletonJobCard.vue?vue&type=style&index=0&id=ae34e0c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae34e0c2"]])

export default __exports__